/* ==========================================================================
   hearth-parent-postcode.js — delivery checker inside step 5
   --------------------------------------------------------------------------
   Ported from the checker in sections/main-cart-footer.liquid, which is where
   this intelligence has always lived. Same postcode classification, same
   out-of-area wording, same sessionStorage key ('bsd_postcode') — so a
   postcode entered here is already filled in when the customer reaches the
   cart, and vice versa.

   ONE DELIBERATE DIFFERENCE FROM THE CART VERSION
   The cart cannot know which delivery band applies, so it probes Shopify with
   a test lookup against MK8 8DD, reads whether the returned rate says
   "oversized", and quotes a RANGE. This page already knows — the selected
   variant's band is sitting in #hp-bands. So there is no probe, no live rate
   fetch, no fallback range: England and Wales get the exact figure the page
   is already charging, which cannot disagree with the running total.

   Out of area still quotes a range, because that genuinely is not known until
   a human prices it. Phone and WhatsApp are offered inline rather than sending
   anyone to /pages/delivery-quote (Ravi, 20 Aug — do not reintroduce the hop).
   ========================================================================== */
(function () {
  var wrap = document.getElementById('hp-pc');
  var cfgEl = document.getElementById('hp-config');
  if (!wrap || !cfgEl) return;

  var cfg = JSON.parse(cfgEl.textContent);
  var BANDS = JSON.parse(document.getElementById('hp-bands').textContent);
  var pc = cfg.postcode || {};

  /* Same area lists as the cart checker. Keep the two in step. */
  var SCOTLAND = ['AB','DD','DG','EH','FK','G','HS','IV','KA','KW','KY','ML','PA','PH','TD','ZE'];
  var NI = ['BT'];
  var CROWN = ['IM','JE','GY'];

  var input = document.getElementById('hp-pc-input');
  var btn = document.getElementById('hp-pc-btn');
  var out = document.getElementById('hp-pc-result');
  var delSel = document.getElementById('hp-del');

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function money(p) { return '£' + (p / 100).toFixed(2); }

  function classify(raw) {
    var s = String(raw || '').replace(/\s/g, '').toUpperCase();
    if (s.length < 5) return 'invalid';
    var m = s.match(/^([A-Z]{1,2})/);
    if (!m) return 'invalid';
    var area = m[1];
    if (NI.indexOf(area) !== -1) return 'ni';
    if (CROWN.indexOf(area) !== -1) return 'crown';
    if (SCOTLAND.indexOf(area) !== -1) return 'scotland';
    return 'ew';
  }

  /* The band is known, not probed — read it straight off the chosen variant. */
  function band() {
    var el = document.getElementById('hp-vid');
    var id = el ? el.value : null;
    if (!id || !BANDS[id]) return null;
    return BANDS[id].band;
  }
  function rateNow() {
    var b = band();
    if (b === null) return null;
    return b === 'oversized' ? cfg.rateOversized : cfg.rateStandard;
  }
  function rangeNow() {
    return band() === 'oversized' ? pc.rangeOversized : pc.rangeStandard;
  }

  function renderOk(postcode) {
    var rate = rateNow();
    var arrive = document.getElementById('hp-arrive');
    /* Reuse the arrival wording the page has already worked out rather than
       recomputing it here — two date engines would drift apart. */
    var when = arrive && arrive.style.display !== 'none' ? arrive.innerText.replace(/\s+/g, ' ').trim() : '';
    out.innerHTML =
      '<div class="hp__pcres hp__pcres--ok">'
      + '<p class="hp__pcres__t">' + esc(pc.okTitle) + '</p>'
      + (rate === null ? '' : '<p>' + esc(pc.okRateLead) + ' <strong>' + money(rate) + '</strong> ' + esc(pc.vatSuffix) + '</p>')
      + (when ? '<p>' + esc(when) + '</p>' : '')
      + '</div>';
  }

  function renderQuote(postcode) {
    out.innerHTML =
      '<div class="hp__pcres hp__pcres--quote">'
      + '<p><strong>' + esc(postcode) + '</strong> — ' + esc(pc.quoteLead) + '</p>'
      + '<p>' + esc(pc.quoteRangeLead) + ' <strong>' + esc(rangeNow()) + '</strong> ' + esc(pc.vatSuffix) + '. ' + esc(pc.quoteRangeNote) + '</p>'
      + '<p class="hp__pccontact">'
      + '<a href="tel:' + esc(pc.phoneHref) + '">' + esc(pc.phoneLabel) + '</a>'
      + ' &nbsp;·&nbsp; '
      + '<a href="' + esc(pc.whatsappHref) + '" rel="noopener">' + esc(pc.whatsappLabel) + '</a>'
      + '</p>'
      + '</div>';
  }

  function renderInvalid() {
    out.innerHTML = '<div class="hp__pcres hp__pcres--bad">' + esc(pc.invalid) + '</div>';
  }

  function check(raw) {
    var kind = classify(raw);
    var tidy = String(raw || '').replace(/\s/g, '').toUpperCase();
    if (kind === 'ew') renderOk(tidy);
    else if (kind === 'invalid') renderInvalid();
    else renderQuote(tidy);
  }

  /* Step 5 stays one line for the collection majority; the field appears the
     moment pallet delivery is chosen. */
  function syncVisibility() {
    var on = delSel && delSel.value === 'deliver';
    wrap.className = 'hp__pc' + (on ? ' is-on' : '');
    if (on && input && !out.innerHTML) {
      var saved = '';
      try { saved = sessionStorage.getItem('bsd_postcode') || ''; } catch (e) {}
      if (saved) { input.value = saved; check(saved); }
    }
  }

  if (btn) {
    btn.addEventListener('click', function () {
      var v = input.value.trim();
      try { sessionStorage.setItem('bsd_postcode', v); } catch (e) {}
      check(v);
    });
  }
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); btn.click(); }
    });
    /* Clear a stale answer the moment the field is edited, so an old
       postcode's result can never sit beside a different one. */
    input.addEventListener('input', function () {
      out.innerHTML = '';
      try { sessionStorage.removeItem('bsd_postcode'); } catch (e) {}
    });
  }

  /* Re-price the answer when the slab changes — a 1500 × 900 moves the figure
     from £78 to £130, and a stale answer here would contradict the total. */
  document.addEventListener('change', function () {
    setTimeout(function () {
      syncVisibility();
      if (out.innerHTML && input && input.value.trim()) check(input.value.trim());
    }, 0);
  }, true);

  syncVisibility();
})();